module.exports = __webpack_public_path__ + "img/pic_11.8553dd31.jpg";